import { ErrorBoundary } from '../../components/ErrorBoundary'
import { Router } from './Router'

const App = () => (
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
)

export { App }
